// Slice da stores feature — só UI state (selectedStoreId). A aba ativa vive na
// URL (/empresas/:slug/:tab), não aqui — persiste no F5. Dados de domínio ficam
// no cache do RTK Query.
import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

export type StoreTab = 'overview' | 'pricing' | 'team' | 'performance' | 'settings';

export interface StoresUiState {
  selectedStoreId: string | null;
}

const initialState: StoresUiState = {
  selectedStoreId: null,
};

const storesSlice = createSlice({
  name: 'storesUi',
  initialState,
  reducers: {
    storeSelected(state, action: PayloadAction<{ id: string | null }>) {
      state.selectedStoreId = action.payload.id;
    },
  },
});

export const { storeSelected } = storesSlice.actions;
export const storesUiReducer = storesSlice.reducer;

export const selectSelectedStoreId = (s: { storesUi: StoresUiState }): string | null =>
  s.storesUi.selectedStoreId;
